import React from "react";
import {IconButton} from "@mui/material";
import {EXPANDED, useMuseumFilterDispatch} from "./museumFilterContext";
import {ChevronLeft} from "@mui/icons-material";

export const CollapsedToolbar = () => {
    const dispatch = useMuseumFilterDispatch()

    const onExpand = () => dispatch({type: EXPANDED})

    return (
        <IconButton
            size={"large"}
            edge={"start"}
            onClick={onExpand}

        >
            <ChevronLeft />
        </IconButton>
    )
}